import * as React from 'react';

function Chevron(props) {
	return (
		<svg
			aria-label={`chevron icon`}
			width={'11'}
			height={'7'}
			viewBox={'0 0 11 7'}
			fill={'none'}
			xmlns={'http://www.w3.org/2000/svg'}
			{...props}
		>
			<title>chevron icon</title>
			<path
				d={'M1.46927 1.00004L5.71191 5.24268L9.99719 1.04311'}
				stroke={'#1F1F1F'}
				strokeWidth={'2'}
			/>
		</svg>
	);
}

export default Chevron;
